module.exports = __webpack_public_path__ + "img/eqg.30ed019c.svg";